module.exports = __webpack_public_path__ + "public/img/wechat.3faeabd8.png";